<script lang="ts">
  import { v4 as uuidv4 } from 'uuid';
  import Blocks from '../Blocks.svelte';

  import LookupLink from './LookupLink.svelte';

  import { EditBox, getDefaultDevProps, type DevProps } from '../dev/index';

  //
  // Import blocks from a referenced content type
  //
  import type { ReferenceBlock } from 'query-strapi-v4';
  import EditorJs from './EditorJs.svelte';

  type Block = $$Generic<ReferenceBlock | undefined>;
  export let block = undefined as ReferenceBlock;
  export let dev: DevProps = getDefaultDevProps();

  const referencedContentBlockKeys = () => {
    // article, tutorial, id...
    const properties = Object.keys(block.lookup_options);
    return properties.filter((property) => {
      const blockLookup = block.lookup_options[property];
      // test if it's well formed
      return blockLookup?.hasOwnProperty('data') && blockLookup.data !== null;
    });
  };
  const blockKeys = block?.lookup_options ? referencedContentBlockKeys() : [];
  const getEditLink = (key: string) => {
    const baseEditUrl = '/admin/content-manager/collectionType/api::';
    if (blockKeys.length > 0) {
      const targetCollectionItem = block.lookup_options[key];
      const targetId = targetCollectionItem?.data?.id;
      return `${dev.strapiBaseUrl}${baseEditUrl}${key}.${key}/${targetId}`;
    }
    return undefined;
  };
</script>

{#if block?.editor}
  <EditorJs editor={block.editor} />
{/if}
{#if typeof block !== 'undefined' && block?.lookup_options}
  <!-- <pre class="dark:text-white">{JSON.stringify(block, null, 2)}</pre> -->
  {#if block?.reference_type === 'link'}
    <!-- <pre class="dark:text-white">{JSON.stringify(block, null, 2)}</pre> -->
    {#each blockKeys as key (uuidv4())}
      {#if block?.lookup_options[key]?.data?.attributes?.meta}
        <LookupLink collectionType={key} meta={block.lookup_options[key]?.data?.attributes?.meta} />
      {/if}
    {/each}
  {:else}
    {#each blockKeys as key (uuidv4())}
      <!-- {JSON.stringify(dev)} -->
      <EditBox isDev={dev.isDev} button={{ editUrl: getEditLink(key), text: 'Edit Lookup' }}>
        <Blocks blocks={block.lookup_options[key]?.data?.attributes?.blocks} on:analytics-event />
      </EditBox>
    {/each}
  {/if}
{/if}
